export class AppError {
  constructor(public message?: any) {
    console.log('here app error: ', message);
  }
}
